import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export default function PlayerRegionGate({ children }) {
  const { pathname } = useLocation();
  const isAdmin = /^\/(?:admin|c)(?:\/|$)/.test(pathname);
  const [access, setAccess] = useState(null);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    if (isAdmin) return undefined;
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get("/player-access", { skipMaintenance: true });
        if (!cancelled) setAccess({ ...data, pathname });
      } catch {
        if (!cancelled) setAccess({ pathname, allowed: false, message: "We couldn't verify your region. Please try again." });
      }
    };
    check();
    const onFocus = () => { if (document.visibilityState !== "hidden") check(); };
    const timer = window.setInterval(onFocus, 60000);
    window.addEventListener("focus", onFocus);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
    };
  }, [isAdmin, pathname, retry]);

  if (isAdmin) return children;
  const checked = access?.pathname === pathname;
  if (checked && access.allowed === true) return children;
  return (
    <main className="grid min-h-screen place-items-center bg-[#030705] px-6 text-white">
      <div className="max-w-md text-center">
        <h1 className="mb-3 text-2xl font-semibold">{checked ? "Player access unavailable" : "Checking availability…"}</h1>
        {checked && <p className="text-sm text-white/65">{access.message}</p>}
        {checked && access.country !== "NP" && (
          <button type="button" className="mt-6 rounded-full border border-white/20 px-5 py-2"
            onClick={() => { setAccess(null); setRetry((value) => value + 1); }}>Try again</button>
        )}
      </div>
    </main>
  );
}
